/**
 * Project Utilities - Helper functions for multi-project management
 * Extracted from MultiProjectContext.tsx for better modularity
 */

// Helper functions for handling both namespaced and direct node IDs
export const isNamespacedId = (id: unknown): boolean => {
  if (typeof id !== 'string') return false;
  return id.includes(':') && id.split(':').length === 2;
};

export const getNodeId = (id: unknown): string => {
  if (typeof id !== 'string') return String(id ?? '');
  return isNamespacedId(id) ? id.split(':')[1] : id;
};

export const getProjectIdFromNodeId = (id: unknown, defaultProject?: string): string => {
  if (typeof id !== 'string') return defaultProject || 'default';
  return isNamespacedId(id) ? id.split(':')[0] : (defaultProject || 'default');
};

// Project colors for visual separation
export const PROJECT_COLORS = [
  '#4A90E2', // Ocean Blue
  '#27AE60', // Forest Green
  '#E67E22', // Sunset Orange
  '#8E44AD', // Grape Purple
  '#E74C3C', // Cherry Red
  '#34495E', // Slate Gray
  '#F1C40F', // Gold Yellow
  '#3498DB', // Sky Blue
  '#16A085', // Teal
  '#D35400', // Pumpkin
];

// Hash function for consistent color assignment
export const hashCode = (str: string): number => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  return Math.abs(hash);
};

// Get project color
export const getProjectColor = (projectId: string, customColor?: string): string => {
  if (customColor) return customColor;
  return PROJECT_COLORS[hashCode(projectId) % PROJECT_COLORS.length];
};
